import _lib from '../_lib';
import active from './active/index';
import {MedicationsNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'medications';
  let activations = [
    {
      name: 'medications',
      test: api.messageIs(MedicationsNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

